import { render } from "./JoinPublicationTwoFactorEnroll.vue.js?vue&type=template&id=347c42a2!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationTwoFactorEnroll.vue?vue&type=template&id=347c42a2"
import script from "./JoinPublicationTwoFactorEnroll.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationTwoFactorEnroll.vue?vue&type=script&lang=js"
export * from "./JoinPublicationTwoFactorEnroll.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationTwoFactorEnroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/login-signup-page/join-publication/JoinPublicationTwoFactorEnroll.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "347c42a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('347c42a2', __exports__)) {
    api.reload('347c42a2', __exports__)
  }
  
  module.hot.accept("./JoinPublicationTwoFactorEnroll.vue.js?vue&type=template&id=347c42a2!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationTwoFactorEnroll.vue?vue&type=template&id=347c42a2", () => {
    api.rerender('347c42a2', render)
  })

}


export default __exports__